import { Component, OnDestroy, OnInit } from '@angular/core';
import { DetailViewNotifyService } from '../../shared/detailview-notify.service';
import { BaseControlComponent } from '../base-control/base-control.component';
import { TranslateService } from '@ngx-translate/core';
import { DetailViewComponent } from '../../detail-view.component';

// checkbox control
@Component({
    selector: 'check-box',
    templateUrl: './check-box.component.html',
    styleUrls: ['./check-box.component.scss'],
    standalone: false
})
export class CheckBoxComponent extends BaseControlComponent implements OnInit, OnDestroy {
  constructor(
    public detailViewNotifyService: DetailViewNotifyService,
    public detailViewComponent: DetailViewComponent,
    public translate: TranslateService
  ) {
    super(detailViewNotifyService, translate);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }
}
